import { useParams } from "react-router-dom";
import { useRef } from "react";
import ContentBox from "../common/content-box";
import queries from "@/queries";
import { useQuery } from "@tanstack/react-query";
import { useRawDsdTableSelection } from "@/hooks/use-raw-dsd-table-selection";

const DSDContent = ({ tableId }: { tableId: string }) => {
  const { workbookId } = useParams();
  const containerRef = useRef<HTMLDivElement>(null);
  // 주입된 표 HTML 에 셀 드래그 선택 + Ctrl+C 복사를 붙인다(다른 DSD 표와 동일 동작).
  // 컨테이너는 로딩 중에도 마운트된 채여야 훅이 표 주입을 관찰할 수 있다.
  useRawDsdTableSelection(containerRef, "final-preview-dsd-selection-style");
  const { data, isLoading } = useQuery({
    ...queries.workbook(workbookId!)._ctx.tables(tableId)._ctx.dsdView(),
    enabled: !!workbookId && !!tableId,
  });
  return (
    <ContentBox className="mt-5">
      {isLoading && <span className="loading-spinner" />}
      <div
        ref={containerRef}
        dangerouslySetInnerHTML={{
          __html: data?.html?.replaceAll("#FEFCE8", "#FFFFFF") || "",
        }}
      />
    </ContentBox>
  );
};

export default DSDContent;
